// extracted by mini-css-extract-plugin
export var navLinkItem = "navigationicon-module--navLinkItem--f2e3d";